<template>
  <div>
    <a
      href="javascript:void(0);"
      v-bind:class="`${linkClass} lightbox`"
      v-on:click.stop="toggleDisclosure"
      >{{ linkText }}</a
    >
    <div class="tool-tip">
      <div
        v-bind:class="`tool-tip__box ${tooltipBoxClass}`"
        v-show="shownDisclosure"
        :style="{ width: width + 'px' }"
      >
        <!--v-on:click.stop="hideDisclosure">-->
        <div class="tool-tip__arrow"></div>
        <div class="tool-tip__content" v-html="copy"></div>
      </div>
    </div>
  </div>
</template>
<script>
import eventHub from 'apps/bankrate-events'

export default {
  props: ['copy', 'linkText', 'direction', 'linkClass', 'width'],

  data: function() {
    return {
      shownDisclosure: false
    }
  },

  created() {
    eventHub.$on('bankrate-disclosure::close', this.hideDisclosure)
  },

  computed: {
    tooltipBoxClass: function() {
      return this.direction ? '--' + this.direction : ''
    }
  },

  methods: {
    toggleDisclosure: function() {
      this.shownDisclosure = this.shownDisclosure !== true
    },
    hideDisclosure: function() {
      this.shownDisclosure = false
    }
  }
}
</script>
